
// ProductsEcosystem.js

import React from 'react';
import '../../styles/products/ProductsEcosystem.css';

import EcoSystemDiagramTransparent from '../../images/diagrams/ecosystem/nichewareEcosystemDiagramTransparent.png';
import TitleField from '../text/TitleField';
import TextField from '../text/TextField';

// media query hook
import { useMediaQuery } from '../../hooks/useMediaQuery';
import { StaggerGroup, StaggerItem } from '../motion/Stagger';

const ProductsEcosystem = () => {
    const isMobile = useMediaQuery('(max-width: 767px)');

    return (
        <section className="product-ecosystem-section">
            <StaggerGroup as="div" className='product-title-container' staggerChildren={0.18} delayChildren={0.1}>
                <StaggerItem as="div" className='product-eyebrow-label'>
                    BUILT FOR YOUR UNIQUE NEEDS
                </StaggerItem>
                <StaggerItem as="div" className='product-tile-advertisment'>
                    <TitleField title={<>Custom Software Built for Your <span className="product-ecosystem-title-highlight">Niche</span></>} bold={true} level={1} fontSize='3rem' />
                </StaggerItem>

                <StaggerItem as="div" className='product-paragraph-advertisment'>
                    {!isMobile && (
                        <TextField text='No more compromising for off the shelf solutions. No more trying to fit your business into a mold.
                            Get a custom solution that fits your unique needs at an affordable price.' fontColor='#898989' />
                    )}

                    {isMobile && (
                        <TextField text='No more compromising. Get a custom solution that fits your unique needs at
                            an affordable price.' fontColor='#898989' />

                    )}
                </StaggerItem>

                <StaggerItem as="div" className="product-ecosystem-diagram-container">
                    <img
                        src={EcoSystemDiagramTransparent}
                        alt="NicheWare ecosystem diagram"
                        className="product-ecosystem-diagram"
                        draggable={false}
                    />
                </StaggerItem>
            </StaggerGroup>
        </section>
    );
};

export default ProductsEcosystem;
